import { APIAuthService } from "./APIService"

const uploadFile = file => {
  const formData = new FormData()
  formData.append("file", file)

  return APIAuthService.post('/users/:userId/files', formData);
}


export const FileService = {
  uploadFile,
}
